import React from "react";
import Popup from "reactjs-popup";

const Help = (props) => {
  const lang = props.lang;
  return (
    <Popup
      modal
      closeOnDocumentClick={true}
      open={props.openHelp}
      onClose={() => {
        props.setOpenHelp(false);
      }}
    >
      <div className="popup-help">
        <span style={{ color: "#000", fontSize: "24px", float: "right" }}>
          <i className="fa fa-question-circle" style={{ fontSize: "24px" }}></i>
        </span>
        <span
          style={{
            color: "#000",
            fontSize: "24px",
            float: "left",
            marginRight: "20px",
          }}
        >
          <i className="fa fa-question-circle" style={{ fontSize: "24px" }}></i>
        </span>
        <p>
          {lang.HelpQuestions}:{" "}
          <a href="mailto:info@myshs.com">
            <strong>info@myshs.com</strong>
          </a>
        </p>
        <hr style={{ color: "#000" }} />
        <div
          style={{
            fontSize: "14px",
            color: "#666",
            fontFamily: "Arial, Helvetica, sans-serif",
            marginTop: "8px",
          }}
        >
          <h4>
            <strong>• {lang.WhySign}</strong>
          </h4>
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            {lang.ContractAgreement}{" "}
          </div>

          <h4>
            <strong>• {lang.ContactWho}</strong>
          </h4>
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            {lang.HitReply}:{" "}
            <a href="mailto:info@myshs.com">
              <strong>info@myshs.com</strong>
            </a>
          </div>
          <h4>
            <strong>• {lang.MultipleDocuments}</strong>
          </h4>
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            {lang.PartDocument}
          </div>

          <h4>
            <strong>• {lang.UseCode}</strong>
          </h4>
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            {lang.EmailedCode}{" "}
            <a href="/">
              <strong>{lang.THISLINK}</strong>
            </a>{" "}
            {lang.EmailedCode2}
          </div>
          <h4>
            <strong>• {lang.GetACopy}</strong>
          </h4>
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            {lang.AfterSign}
          </div>
        </div>
        <a
          className="subbtn"
          onClick={() => {
            props.setOpenHelp(false);
          }}
        >
          {lang.Close}
        </a>
      </div>
    </Popup>
  );
};
export default Help;
